import React, { useState, useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
//import TopBar from '../../../components/TopBar/TopBarADM';
import ViewSolicitacaoModal from './ViewSolicitacaoModalADM';
import api from '../../../services/api';
import '../../Prefeitura/Home/Home.css';
import { TextField, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import API_CONFIG from '../../../config/api.config';

const SolicitacoesPrefeitura = () => {
  const { idPrefeitura } = useParams();
  const location = useLocation();
  const nomePrefeitura = location.state?.nomePrefeitura || '';
  const navigate = useNavigate();

  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [selectedPrefeitura, setSelectedPrefeitura] = useState('');
  const [prefeituras, setPrefeituras] = useState([]);
  const [dataInicio, setDataInicio] = useState('');
  const [dataFim, setDataFim] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedSolicitacao, setSelectedSolicitacao] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [solicitacoes, setSolicitacoes] = useState([]);
  const [solicitacoesFiltradas, setSolicitacoesFiltradas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [paginacao, setPaginacao] = useState(null);
  const [tipoUsuario, setTipoUsuario] = useState('');

  useEffect(() => {
    const handleMenuChange = (event) => {
      setIsMenuExpanded(!event.detail.isCollapsed);
    };
    window.addEventListener('menuStateChange', handleMenuChange);
    return () => window.removeEventListener('menuStateChange', handleMenuChange);
  }, []);

  const handleTipoUsuarioChange = (value) => {
    setTipoUsuario(value);
  };

  const limitarTexto = (texto, limite = 50) => {
    if (!texto) return '';
    if (texto.length <= limite) return texto;
    return texto.substring(0, limite) + '...';
  };

  const formatarDataParaComparacao = (dataString) => {
    if (!dataString) return new Date('1900-01-01');
    const dataSemHora = dataString.split(' ')[0];
    return new Date(dataSemHora);
  };

  // Buscar solicitações da API com base na prefeitura selecionada e página
  const buscarSolicitacoes = async () => {
    try {
      setLoading(true);
      const params = {
        page: currentPage,
        per_page: 8
      };

      if (selectedPrefeitura) {
        params.prefeitura = selectedPrefeitura;
      }

      const url = API_CONFIG.ENDPOINTS.SOLICITACOES.LISTAR;
      //console.log('URL da API:', url);
      //console.log('Parâmetros:', params);

      const response = await api.get(url, { params });
      //console.log('Resposta da API:', response.data);

      const data = response.data;

      if (data && data.status && data.solicitacoes) {
        //console.log('Dados de paginação recebidos:', data.solicitacoes);
        setPaginacao(data.solicitacoes);

        const fetchedSolicitacoes = data.solicitacoes.data; // Salva os dados buscados
        setSolicitacoes(fetchedSolicitacoes); // Armazena todas as solicitações da página atual

        // Extrair prefeituras únicas das solicitações e atualizar o estado 'prefeituras'
        const uniquePrefeituras = fetchedSolicitacoes.reduce((acc, solicitacao) => {
          if (solicitacao.prefeitura && !acc.find(p => p.PRE_ID === solicitacao.prefeitura.PRE_ID)) {
            acc.push(solicitacao.prefeitura);
          }
          return acc;
        }, []);
        // Adicionar as prefeituras já existentes no dropdown que podem não estar na página atual
        // Isso garante que a prefeitura selecionada continue aparecendo mesmo se não houver solicitações dela na página
        const combinedPrefeituras = [...prefeituras, ...uniquePrefeituras.filter(up => !prefeituras.find(p => p.PRE_ID === up.PRE_ID))];

        // Opcional: Ordenar as prefeituras pelo nome
        combinedPrefeituras.sort((a, b) => a.PRE_NOME.localeCompare(b.PRE_NOME));
        
        setPrefeituras(combinedPrefeituras); // Atualiza a lista de prefeituras para o dropdown

        setSolicitacoesFiltradas(fetchedSolicitacoes); // Inicialmente, filtrados são iguais aos buscados
      } else {
        //console.log('Dados inválidos recebidos da API:', data);
        setPaginacao(null);
        setSolicitacoes([]);
        setSolicitacoesFiltradas([]);
        // Limpar a lista de prefeituras se não houver solicitações, exceto se uma prefeitura já estiver selecionada
        if (!selectedPrefeitura) {
           setPrefeituras([]);
        } else {
           // Se uma prefeitura estiver selecionada e não houver dados, manter apenas essa prefeitura no dropdown
           const currentSelectedPref = prefeituras.find(p => p.PRE_ID === selectedPrefeitura);
           setPrefeituras(currentSelectedPref ? [currentSelectedPref] : []);
        }
      }
    } catch (error) {
      //console.error('Erro ao buscar solicitações:', error);
      //console.error('Detalhes do erro:', error.response?.data);
      setPaginacao(null);
      setSolicitacoes([]);
      setSolicitacoesFiltradas([]);
       // Limpar a lista de prefeituras em caso de erro, exceto se uma prefeitura já estiver selecionada
      if (!selectedPrefeitura) {
         setPrefeituras([]);
      } else {
         const currentSelectedPref = prefeituras.find(p => p.PRE_ID === selectedPrefeitura);
         setPrefeituras(currentSelectedPref ? [currentSelectedPref] : []);
      }
    } finally {
      setLoading(false);
    }
  };

  // Filtrar solicitações localmente por data (agora sobre o estado 'solicitacoes')
  const filtrarSolicitacoes = () => {
    let resultado = [...solicitacoes]; // Filtra sobre as solicitações da página atual

    // Aplicar filtro de data início
    if (dataInicio) {
      const inicio = new Date(dataInicio);
      resultado = resultado.filter(solicitacao => {
        const dataSolicitacao = formatarDataParaComparacao(solicitacao.SOL_DATA_VINCULACAO);
        return dataSolicitacao >= inicio;
      });
    }

    // Aplicar filtro de data fim
    if (dataFim) {
      const fim = new Date(dataFim);
      fim.setHours(23, 59, 59, 999);
      resultado = resultado.filter(solicitacao => {
        const dataSolicitacao = formatarDataParaComparacao(solicitacao.SOL_DATA_VINCULACAO);
        return dataSolicitacao <= fim;
      });
    }

    setSolicitacoesFiltradas(resultado);
  };

  // Efeito para buscar solicitações quando mudar a página ou a prefeitura selecionada
  useEffect(() => {
    // Limpar as solicitações e prefeituras ao iniciar uma nova busca
    setSolicitacoes([]);
    setSolicitacoesFiltradas([]);
    // Não limpar prefeituras aqui, pois queremos acumular as prefeituras encontradas em todas as páginas
    
    buscarSolicitacoes();
  }, [currentPage, selectedPrefeitura]);

  // Efeito para aplicar o filtro de data quando as datas ou as solicitações da página mudarem
  useEffect(() => {
    filtrarSolicitacoes();
  }, [dataInicio, dataFim, solicitacoes]); // Depende de solicitacoes para filtrar os dados da página atual

  // Após carregar as solicitações, abrir o modal se houver abrirModalId
  useEffect(() => {
    if (solicitacoes.length > 0 && location.state?.abrirModalId) {
      const solicitacao = solicitacoes.find(s => s.SOL_ID === location.state.abrirModalId || s.SOL_ID === Number(location.state.abrirModalId));
      if (solicitacao) {
        setSelectedSolicitacao(solicitacao);
        setIsModalOpen(true);
        // Limpar o state para evitar reabertura futura
        navigate(location.pathname, { replace: true });
      }
    }
    // eslint-disable-next-line
  }, [solicitacoes, location.state, navigate, location.pathname]);

  const nextPage = () => {
    if (paginacao?.next_page_url) {
      const url = new URL(paginacao.next_page_url);
      const page = url.searchParams.get('page');
      setCurrentPage(Number(page));
    }
  };

  const prevPage = () => {
    if (paginacao?.prev_page_url) {
      const url = new URL(paginacao.prev_page_url);
      const page = url.searchParams.get('page');
      setCurrentPage(Number(page));
    }
  };

  const handleViewSolicitacao = (solicitacao) => {
    setSelectedSolicitacao(solicitacao);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedSolicitacao(null);
  };

  return (
    <div className={`home-container ${isMenuExpanded ? 'menu-expanded' : ''}`}>
      <div className="modal-wrapper">
        <h1 className="modal-title">Solicitações da Prefeitura {nomePrefeitura && `- ${nomePrefeitura}`}</h1>
        <div className="modal-content">
          <div className="search-container" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex', flexWrap: 'wrap' }}>
            <FormControl
              fullWidth
              size="small"
              variant="outlined"
              style={{ marginBottom: 8 }}
            >
              <InputLabel id="select-prefeitura-label">Selecione a Prefeitura</InputLabel>
              <Select
                labelId="select-prefeitura-label"
                value={selectedPrefeitura}
                label="Selecione a Prefeitura"
                onChange={e => {
                  setSelectedPrefeitura(e.target.value);
                  setCurrentPage(1); // Resetar para primeira página ao mudar prefeitura
                }}
              >
                <MenuItem value="">
                  <em>Todas</em>
                </MenuItem>
                {prefeituras.map((pref) => (
                  <MenuItem key={pref.PRE_ID} value={pref.PRE_ID}>
                    {pref.PRE_NOME}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <TextField
              label="Data Início"
              type="date"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={dataInicio}
              onChange={(e) => setDataInicio(e.target.value)}
              inputProps={{ max: dataFim }}
              style={{ marginBottom: 8 }}
            />
            <TextField
              label="Data Fim"
              type="date"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={dataFim}
              onChange={(e) => setDataFim(e.target.value)}
              inputProps={{ min: dataInicio }}
              style={{ marginBottom: 8 }}
            />
            <button
              className="search-button"
              onClick={filtrarSolicitacoes}
              style={{ height: 40, marginBottom: 8, marginLeft: 0 }}
            >
              PROCURAR
            </button>
          </div>
          <div className="cards-grid">
            {loading ? (
              <div className="loading">Carregando...</div>
            ) : solicitacoesFiltradas.length > 0 ? (
              solicitacoesFiltradas.map((solicitacao) => (
                <div key={solicitacao.SOL_ID} className="card">
                  <h2 className="card-title">Solicitação #{solicitacao.SOL_ID}</h2>
                  <div className="card-content">
                    <div className="card-info">
                      <strong>Prefeitura:</strong> {solicitacao.prefeitura.PRE_NOME}
                    </div>
                    <div className="card-info">
                      <strong>Status:</strong> {solicitacao.SOL_STATUS}
                    </div>
                    <div className="card-info">
                      <strong>Data de abertura:</strong> {new Date(solicitacao.SOL_DATA_VINCULACAO).toLocaleDateString('pt-BR')}
                    </div>
                    <div className="card-info">
                      <strong>Quantidade de Itens:</strong> {solicitacao.itens.length}
                    </div>
                    <button 
                      className="ver-cotacao-btn"
                      onClick={() => handleViewSolicitacao(solicitacao)}
                    >
                      Ver Detalhes
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="no-results">
                Nenhuma solicitação encontrada
              </div>
            )}
          </div>
          <div className="pagination">
            {paginacao && (
              <>
                {paginacao.prev_page_url && (
                  <button className="pagination-btn" onClick={prevPage} disabled={loading}>
                    Voltar
                  </button>
                )}
                <span className="pagination-info">
                  Página {paginacao.current_page} de {paginacao.last_page}
                </span>
                {paginacao.next_page_url && (
                  <button className="pagination-btn" onClick={nextPage} disabled={loading}>
                    Próximo
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <ViewSolicitacaoModal
        isVisible={isModalOpen}
        onClose={handleCloseModal}
        solicitacao={selectedSolicitacao}
      />
    </div>
  );
};

export default SolicitacoesPrefeitura; 